// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import {application} from "./application"

import {BootstrapTurboController} from "./bootstrap_toast_controller";
import {TomSelectController} from "@finchi/tom-select-coreui"
import {TurboModalController} from "@finchi/turbo-modal"
import {
  SidebarController,
  SimpleBarController,
  ColorSwitchController,
} from "@finchi/coreui-stimulus"
import BarChartController from "./bar_chart_controller.js"
import WaitingListFormController from "./waiting_list_form_controller.js"
import {UseFormController} from "./user_form_controller";
import {BirthdayInputController} from "./birthday_input_controller";
import {NotificationsController} from "./notifications_controller";

application.register("bootstrap-toast", BootstrapTurboController)
application.register("tom-select", TomSelectController)
application.register("turbo-modal", TurboModalController)
application.register("sidebar", SidebarController)
application.register("simple-bar", SimpleBarController)
application.register("color-switch", ColorSwitchController)
application.register("bar-chart", BarChartController)
application.register("waiting-list-form", WaitingListFormController)
application.register("user-form", UseFormController)
application.register("birthday-input", BirthdayInputController)
application.register("notifications", NotificationsController)
